// @note: Extend only this config object to let TS extends MUI theme with generics
var customTypographyVariants = {
    hint: {
        defaultTag: 'div',
        style: function (theme) { return ({
            fontSize: '0.75rem',
            lineHeight: '1.2rem',
            letterSpacing: 0,
            color: theme.palette.grey[800],
        }); },
    },
};
var preparedTypographyVariants = customTypographyVariants;
export var customTypographyVariantMapping = Object.keys(preparedTypographyVariants).reduce(function (acc, key) {
    var variantName = key;
    acc[variantName] = preparedTypographyVariants[variantName].defaultTag;
    return acc;
}, {});
export var makeCustomTypographyStyleOverrides = function (theme) {
    return Object.keys(preparedTypographyVariants).reduce(function (acc, key) {
        var variantName = key;
        acc[variantName] = preparedTypographyVariants[variantName].style(theme);
        return acc;
    }, {});
};
